package com.crowpay.extensions

import com.crowpay.Contractor


val Contractor.contactFullName: String get() = "$contactFirstName $contactLastName"